import i18n from 'i18n';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import { Control, Controller } from 'react-hook-form';
import { Radio } from 'antd';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';

const FirstValuationStock = ({
  control,
  index,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
}) => {
  return (
    <div className="flex items-center gap-2">
      <FormLabel>{i18n.t(LOCALS.stock_availability)}:</FormLabel>
      <Controller
        name={`productList.${index}.firstValuationStock`}
        control={control}
        render={({ field }) => (
          <Radio.Group {...field} className="w-full">
            <Radio value={2}>{i18n.t('available')}</Radio>
            <Radio value={1}>{i18n.t('unavailable')}</Radio>
          </Radio.Group>
        )}
      />
    </div>
  );
};

export default FirstValuationStock;
